<section class="trust-area pt-100 pb-70">
    <div class="container">
        <div class="section-title" appReveal>
            <h2>One Country, a Thousand Backdrops</h2>
            <p>From dramatic mountains and desert silence to turquoise coastlines and modern city settings.</p>
        </div>

        <div *ngIf="backdropsLoading" class="row">
            <div class="col-sm-6 col-lg-4" *ngFor="let item of backdropSkeletonItems">
                <div class="service-item skeleton">
                    <div class="service-inner">
                        <h3 class="skeleton-text skeleton-title">&nbsp;</h3>
                        <p class="skeleton-text skeleton-desc">&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!backdropsLoading && backdropsError" class="row">
            <div class="col-12">
                <div class="service-feedback service-error">
                    <strong>Unable to load backdrops.</strong>
                    <span>{{ backdropsError }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="!backdropsLoading && !backdropsError && backdrops.length === 0" class="row">
            <div class="col-12">
                <div class="service-feedback service-empty">
                    No backdrops were returned from WordPress. Add items under WordPress and refresh this page.
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!backdropsLoading && !backdropsError && backdrops.length > 0">
            <div class="col-sm-6 col-lg-4"
                 [class.offset-sm-3]="needsSmOffset(i, backdrops.length)"
                 [class.offset-lg-0]="needsSmOffset(i, backdrops.length)"
                 *ngFor="let item of backdrops; trackBy: trackByBackdrop; let i = index"
                 appReveal revealVariant="card" [revealDelay]="i * 90">
                <div class="service-item">
                    <div class="service-inner">
                        <h3>{{ item.title }}</h3>
                        <p *ngIf="item.description">{{ item.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="work-area work-area-three pb-100">
    <div class="container-fluid">
        <div class="section-title" appReveal>
            <h2>Scenes You Can Build In Oman</h2>
        </div>

        <div *ngIf="scenesLoading" class="row">
            <div class="col-sm-6 col-lg-6" *ngFor="let item of sceneSkeletonItems">
                <div class="work-item skeleton"></div>
            </div>
        </div>

        <div *ngIf="!scenesLoading && scenesError" class="row">
            <div class="col-12">
                <div class="service-feedback service-error">
                    <strong>Unable to load scenes.</strong>
                    <span>{{ scenesError }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="!scenesLoading && !scenesError && scenes.length === 0" class="row">
            <div class="col-12">
                <div class="service-feedback service-empty">
                    No scenes were returned from WordPress. Add items under WordPress and refresh this page.
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!scenesLoading && !scenesError && scenes.length > 0">
            <div class="col-sm-6 col-lg-6" *ngFor="let item of scenes; trackBy: trackByScene; let i = index"
                appReveal revealVariant="card" [revealDelay]="i * 90">
                <div class="work-item">
                    <img *ngIf="item.imageUrl" [src]="item.imageUrl" [alt]="item.imageAlt">
                    <div class="work-content">
                        <h3>{{ item.title }}</h3>
                        <span *ngIf="item.caption">{{ item.caption }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center pt-4">
            <a routerLink="/contact" class="btn cta-btn">Discuss Your Location Vision</a>
        </div>
    </div>
</section>